import React from 'react';
import { Input } from 'tamagui';

interface TimeInputProps {
  placeholder: string;
  value?: string;
  onFocus?: () => void;
  onChangeText?: (val: string) => void;
  onSubmitEditing?: () => void;
  onClick?: () => void;
}

export const TimeInput = React.forwardRef<any, TimeInputProps>(
  ({ placeholder, value, onFocus, onChangeText, onSubmitEditing }, ref) => (
    <Input
      ref={ref}
      flex={1}
      placeholder={placeholder}
      placeholderTextColor="gray10"
      height={72}
      borderWidth={1}
      borderColor="$borderColor"
      backgroundColor="transparent"
      color="$textLight"
      fontSize="$8.5"
      borderRadius={8}
      paddingHorizontal="$5"
      value={value}
      onFocus={onFocus}
      onChangeText={onChangeText}
      onSubmitEditing={onSubmitEditing}
    />
  ),
);
